import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Badge from './Badge';
import { DataStore } from '../stores/DataStore';
import { isDisabled } from '../utils/customPropStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';

const Button = styled<any, any>('button')`
    ${propStyles};
    ${isDisabled};
    &:disabled {
        opacity: 0.5;
    }
`;

Button.defaultProps = {
    display: 'flex',
    flex: ['1 0 0', '0 1 auto'],
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    margin: '0 0 0 10px',
    minHeight: '40px',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'body',
    bgColor: 'gray100',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'white',
        bgColor: 'primary',
    },
    isDisabled: {
        cursor: 'auto',
    },
};

const StarIcon = styled<any, any>(Icon)``;

StarIcon.defaultProps = {
    height: '1.6em',
    width: '1.6em',
    margin: '0 0.25em 0 0',
};

const ButtonText = styled<any, any>('span')`
    ${propStyles};
`;

ButtonText.defaultProps = {
    display: ['none', 'inline'],
};

const WatchListBadge = styled(Badge)``;

WatchListBadge.defaultProps = {
    marginX: 'sm',
    color: 'white',
    bgColor: 'gray500',
    selected: {
        color: 'primary',
        bgColor: 'white',
    },
};

export const WatchListButton: React.SFC<any> = ({
    theme,
    translations,
    count,
    active,
    onClick,
    dataStore,
    ...props
}) => {
    const watchlistConfig =
        dataStore && (dataStore as DataStore).watchListConfig;
    const watchlistButtonText =
        (watchlistConfig && watchlistConfig.label) || 'Watch List';
    const watchlistButtonTitle =
        (watchlistConfig && watchlistConfig.title) || 'Toggle Watch List';
    const showIcon = watchlistConfig
        ? watchlistConfig.hideChild !== 'icon'
        : true;
    const showText = watchlistConfig
        ? watchlistConfig.hideChild !== 'text'
        : true;
    let defaultIcon = 'WatchlistButtonOutlineIcon';
    let activeIcon = 'WatchlistButtonIcon';
    if (watchlistConfig && watchlistConfig.icon) {
        if (typeof watchlistConfig.icon === 'string') {
            defaultIcon = watchlistConfig.icon;
        } else {
            if (watchlistConfig.icon.default) {
                defaultIcon = watchlistConfig.icon.default;
            }
            if (watchlistConfig.icon.active) {
                activeIcon = watchlistConfig.icon.active;
            }
        }
    }
    const iconFileName = active ? activeIcon : defaultIcon;
    return (
        <Button
            title={translate(translations, watchlistButtonTitle)}
            onClick={onClick}
            data-selected={active}
            disabled={count === 0 && !active}
            {...props}
            {...theme.WatchListButton}
        >
            {showIcon && (
                <StarIcon
                    fileName={iconFileName}
                    data-selected={active}
                    {...theme.WatchListButtonIcon}
                />
            )}
            {showText && (
                <ButtonText>
                    <Translate>{watchlistButtonText}</Translate>
                </ButtonText>
            )}
            <WatchListBadge data-selected={active} {...theme.WatchListBadge}>
                {count}
            </WatchListBadge>
        </Button>
    );
};

export default inject('translations', 'dataStore')(
    observer(withTheme(WatchListButton))
) as any;



// WEBPACK FOOTER //
// ./src/Components/WatchListButton.tsx